/**
* @Author: zachalam
* @Date:   2017-01-23T14:15:53-08:00
 * @Last modified by:   Daniel
 * @Last modified time: 2017-04-06T15:32:52-07:00
*/



import React, { Component } from 'react';
import Dashboard from '../components/pages/Dashboard/Dashboard';
import { connect } from 'react-redux';
import { refreshFavs } from '../actions/favActions';
import { refreshMail } from '../actions/mailActions';
import { refreshAccount } from '../actions/profileActions';
import _ from 'lodash';

class DashboardContainer extends Component {
  componentWillMount() {
    // refresh data on new page
    this.props.refresh();
  }


  render() {
    return (
      <Dashboard {...this.props} />
    );
  }
}

const mapStateToProps = (state) => {
    return {
      profile: state.profile,
      favs: state.fav,
      mail: state.mail
    }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    refresh: () => {
      // refresh fav data.
      dispatch(refreshFavs('to',true,5));
      // refresh mail data.
      dispatch(refreshMail('inbox',true,5));
      // refresh account data.
      dispatch(refreshAccount());
    }
  }

}

export default connect(mapStateToProps,mapDispatchToProps)(DashboardContainer);



// WEBPACK FOOTER //
// ./src/containers/DashboardContainer.jsx